
angular.module('qms.directives', [])

.directive('blockList', ['$location', function ($location) {
			return {
					restrict: 'E',
					replace: true,
					scope: {
						args: '<',
						listClass: '<'
					},
					templateUrl: 'html/bullet_list.html'
			}
	}])

.directive('blockImage', ['$location', function ($location) {
			return {
					restrict: 'E',
					replace: true,
					scope: {
						args: '<',
						click: '<'
					},
					templateUrl: 'html/image_content.html'
			}
	}])

	.directive('blockMainContent', ['$location', function ($location) {
				return {
						restrict: 'E',
						replace: true,
						scope: {
							args: '<'
						},
						templateUrl: 'html/main_content.html'
				}
	}])

  .directive('pageMainContent', [function() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				curState: '=',
				curPage: '=',
				tmplt: '<'
			},
			controller: ['$scope',function($scope) {
				$scope.getTmpltUrl = function() {
							 return "html/"+$scope.tmplt;
				};
			}],
			template: '<div ng-include="getTmpltUrl()"></div>'
	}
}])

.directive('condemnContent', [function() {
	return {
		restrict: 'E',
		replace: true,
		transclude: true,
		scope: {
			curState: '=',
			curPage: '='
		},
		controller: ['$scope',function($scope) {
			console.log('Hi from condemnContent');
			console.log($scope.curState);
		}],
		templateUrl: 'html/condemnations.html'
	}
}])

.directive('condemnList', [function() {
	return {
		restrict: 'E',
		replace: true,
		scope: {
			list: '<'
		},
		controller: ['$scope',function($scope) {
			console.log($scope.curState);
			$scope.show = {
				collapsed: true
			};
		}],
		templateUrl: 'html/condemnList.html'
}
}])

.directive('topNavbar', ['$window','$rootScope','$location', 'ArraySvce', function($window, $rootScope, $location, arraySvce) {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				navbarCollapsed: '=',
				curState: '=',
				curPage: '=',
				menuItems: '<',
				winSize: '<',
				next: '=',
				prev: '='
			},
			templateUrl: 'html/top_navbar.html',
			controller: ['$scope','$rootScope','$element',function ($scope, $rootScope, $element) {

				$scope.navbarCollapsed = true;

				$scope.collapseMenu = function() {
						$scope.navbarCollapsed = true;
					}

				$scope.selectBeast = function(beast) {
					$scope.curState.beast = beast;
				};

				$scope.goHome = function() {
					$location.path('');
				};

				$scope.goToRoute = function(name) {
		      var pgIdx = arraySvce.arrIndexOf($scope.menuItems,name,'name');
		      if(pgIdx >= 0 && pgIdx < $scope.menuItems.length) {
		        Object.assign($scope.curPage,  $scope.menuItems[pgIdx]);
						$scope.curPage.pgIdx = pgIdx;
		        $location.path($scope.menuItems[pgIdx].target);
		      };
		    };

			}]
	}
}])

.directive('commentOverlay', ['$window','$document','$location', function($window, $document, $location) {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				curState: '<',
				curPage: '<',
				winSize: '<',
				commentArgs: '<',
				clickAction: '=',
			},
			templateUrl: 'html/comment_overlay.html',
			controller: ['$scope','$element',function ($scope, $element) {

				$scope.container = $window.document.getElementById('comments_overlay');

				$scope.$watch(function() {return $scope.curState.beast}, function(val) {
					//
				})

				var doResize = function() {
					//
					$scope.$apply();
				}

				angular.element($window).bind('resize', function () {
					doResize();
				});

				setTimeout(function() {
					doResize();
				},60);

				$scope.$on("$destroy", function() {
						angular.element($window).unbind();
				});

			}]
	}
}])

.directive('mainGrid', ['$window','$document','$location', function($window, $document, $location) {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				curState: '=',
				gridV: '<',
				gridH: '<',
				overlayArgs: '<',
				gridKey: '=',
				clickAction: '=',
				ready: '='
			},
			templateUrl: 'html/main_grid.html',
			controller: ['$scope','$element',function ($scope, $element) {

				$scope.winSize = {
					w: $window.innerWidth,
					h: $window.innerHeight
				}

				$scope.eld = {
					count: 0,
					val: 0
				}

				$scope.toggleGridKey = function() {
					$scope.gridKey.show = !$scope.gridKey.show;
				};

				$scope.container = $window.document.getElementById('grid');

				var doGridElements = function() {
					$scope.gridEl = [];
					$scope.elWidth = (100/$scope.gridH.length) + "%";
					$scope.colNames = $scope.gridH.map(function(v) {	return v;	});
					$scope.rowNames = $scope.gridV.map(function(v) {	return v;	});
					for(var i=0; i<$scope.gridV.length; i++) {
						for(var j=0; j<$scope.gridH.length; j++) {
							var el = $scope.gridV[i]+$scope.gridH[j];
							$scope.gridEl.push(el);
						}
					};
					$scope.elDim = getElDim();
				};

				$scope.$watch(function() {return $scope.curState.beast}, function(val) {
					doGridElements();
				})

				var getElDim = function() {
					$scope.winSize.w = $window.innerWidth;
					$scope.winSize.h = $window.innerHeight;
					$scope.container = $document[0].getElementById('grid');
					var d = {
						numSize: ($scope.container.offsetWidth/100)*(100/$scope.gridH.length),
						size: ($scope.container.offsetWidth/100)*(100/$scope.gridH.length) +"px",
						pad: ($scope.container.offsetWidth*0.2/100)*(100/$scope.gridH.length) +"px"
					}
					$scope.ready = true;
					$scope.eld.count++;
					$scope.eld.val = $scope.container.offsetWidth;
					return d;
				}

				var doResize = function() {
					$scope.elDim =  getElDim();
					doGridElements();
					$scope.$apply();
				}

				angular.element($window).bind('resize', function () {
					doResize();
				});

				setTimeout(function() {
					doResize();
				},60);

				$scope.$on("$destroy", function() {
						angular.element($window).unbind();
				});

			}]
	}
}])

.directive('gridNav', ['$window','$rootScope','$location', function($window, $rootScope, $location) {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				curState: '=',
				gridElements: '=',
				cols: '<',
				clickAction: '='
			},
			templateUrl: 'html/nav_grid.html',
			controller: ['$scope','$element',function ($scope, $element) {

				$scope.colClass = "col-xs-"+Math.round(12/$scope.cols);

			}]
	}
}])

.directive('imageLabel', ['$window','$rootScope','$location', function($window, $rootScope, $location) {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				args: '<',
				containerSize: '<',
				click: '<'
			},
			templateUrl: 'html/image_label.html',
			controller: ['$scope','$element',function ($scope, $element) {

				//var top = ($scope.args.pos.y-($scope.args.vOffset+24)) + 'px';
				//var left = ($scope.args.pos.x-80) + 'px';
				var top = ($scope.args.pos.y) + '%';
				var left = ($scope.args.pos.x) + '%';

				$scope.labelPos = {
					top: top,
					left: left
				}

				$scope.$watch(function() {return $scope.containerSize.w}, function(val) {
					$scope.separatorHeight = Math.abs(($scope.containerSize.w / 100) * ($scope.args.vOffset * $scope.containerSize.aspect));
				});

			}]
	}
}])

.directive('sliderCtrl',['$rootScope','$window','$location','$document',function($rootScope,$window,$location,$document) {

			return {
				restrict: 'E',
				scope: {
					options: '=',
					curState: '='
				},
				templateUrl: 'html/slider_parasang.html',
				link: function (scope, element, attributes) {
		    	element.addClass('slider_container');
		    },
				controller: ['$scope','$element',function($scope,$element) {

					$scope.updates = 0;
					$scope.handle = {};
					$scope.lineStyle = {}
					$scope.progressBarStyle = {};
					$scope.winSize = {};

					$scope.winSize.w = $window.innerWidth;

					$scope.getElementDimensions = function () {
				    return { 'h': $element.parent()[0].offsetHeight, 'w': $element.parent()[0].offsetWidth };
				  };


					$scope.getElementOffset = function () {
					    var rect = $element.parent()[0].getBoundingClientRect(),
					    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
					    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
					    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
					}

					$scope.xOffset = function() {
						var el=$element[0];
						var bbox = el.getBoundingClientRect();
						return bbox.x ? bbox.x : bbox.left;
					}

					$scope.track = {
						startX: $scope.getElementOffset().left,
						startY: 0,
						x: 0,
						y: 0
					}

					//slider style objects
					$scope.lineStyle = {
						"background": $scope.options.lineColor
					}

					//alert(JSON.stringify($scope.lineStyle));

					$scope.progressBarStyle = {
						"background": $scope.options.progressColor,
						"width": $scope.curState.curPercent + "%"
					}

					$scope.handleStyle = {
						"border-color": $scope.options.handleColor,
						"background-color": $scope.options.handleInnerColor,
						"cursor": "pointer"
					}

					$scope.$watch(function() {return $scope.curState.curPercent;},function(val) {
						$scope.progressBarStyle.width = val + '%';
					});

					$scope.doMarkers = function() {

						$scope.markers = [];
						$scope.keyMarkers = [];
						$scope.markerStyle = [];
						$scope.keyMarkerStyle = [];
						$scope.keyMarkerLabelStyle = [];

						if($scope.options.showMarkers === true) {
							//if keynames not specified, check steps option and create regular interval markers
							if($scope.options.keyNames === null) {
								if($scope.options.steps > 0) {
									var m = {
										pos:0
									};
									$scope.markers.push(m);

									for(var i=0;i<$scope.options.steps;i++) {
										var pos = (i>0) ? Math.round(i*100/$scope.options.steps) : 0;
										m = {"pos": pos};
										//console.log(m.pos);
										$scope.markers.push(m);
									}

									m = {
									 "pos":100
								 };
								 $scope.markers.push(m);
								 $scope.markerStyle.push(m);
							 }
							 else {
								 //no marker parameters specified so do nothing
							 }
						 }
						 //Create named markers from keyNames array
						 else {
							 if(typeof $scope.options.keyNames == 'object') {
								 $scope.options.steps = $scope.options.keyNames.length-1;
								 var keys = $scope.options.keyNames;
								 for(var i=0;i<$scope.options.keyNames.length;i++) {
									var mStyle = {
 		 								"left": $scope.options.keyNames[i].pos + "%",
 		 								"background": $scope.options.markerBgColor
 		 							};
									var labelStyle = {
										"left": $scope.options.keyNames[i].pos + "%",
										"top": $scope.options.keyVoffset,
										"font-size": $scope.options.keySize,
										"color": $scope.options.keyColor
									}
									$scope.keyMarkerStyle.push(mStyle);
									$scope.keyMarkerLabelStyle.push(labelStyle);
									$scope.keyMarkers.push($scope.options.keyNames[i]);

								 }
							 }
							 else {
								 // no valid keyNames array so do nothing
							 }
						 }
						 $scope.updates ++;
						}
					}

					$scope.posPcent = function(x) {
						var v = ($scope.curState.range > 0) ? (x - $scope.options.minOffset) * 100/$scope.curState.range : 0;
						return v;
					};

					$scope.pcentPos = function(pc) {
						var pos = (pc * $scope.curState.range/100) + $scope.options.minOffset;
						return pos;
					};

					$scope.dimSetup = function(val) {
						$scope.box = {
							h: val.h,
							w: val.w
						}
						$scope.curState.range = Math.round($scope.box.w - ($scope.box.w * 0.06 + $scope.options.maxOffset) - $scope.options.minOffset);
						$scope.track.x = $scope.xLeft($scope.pcentPos($scope.curState.curPercent));
						var pos = $scope.track.x;
						console.log('boxW: '+$scope.box.w+' boxH: '+$scope.box.h+' maxOff: '+$scope.options.maxOffset+' minOff: '+$scope.options.minOffset);
						$element.css({
							 left:  pos + 'px'
						 });
						 $scope.curState.curPos = pos;

					};

						$scope.$watch(function() {return $scope.options},function() {
							$scope.dimSetup($scope.getElementDimensions());
							$scope.doMarkers();
						},true);

				}]//end Controller

			};//end return function

	}])

	.directive('dragHandle', ['$document','$window','ArraySvce', function($document,$window,arraySvce) {
			return {
				restrict: 'A',
				require: '^sliderCtrl',
				link: function($scope,$element,$attrs,$ctrl) {

				},
				controller: ['$scope','$element',function($scope,$element) {

					//var startX = 0, startY = 0, x = 0, y = 0;

					$scope.handle = $element;

					$element.css({
					 left: $scope.options.minOffset + 'px',
					 position: 'relative',
					 cursor: 'pointer'
					});

					$element.on('mousedown', function(event) {
						event.preventDefault();
						event.stopPropagation();
					});

					$scope.clickTap = function(event) {
						  $scope.track.startX = $scope.xOffset();
							$scope.track.x = event.center.x - $scope.track.startX;
							var pos = $scope.xLeft($scope.track.x);
							$scope.curState.curPos = pos;
							$scope.track.startX = event.center.x - $scope.curState.curPos;
							$scope.curState.curPercent = $scope.posPcent(pos);
							if($scope.keyMarkers.length == 0 && $scope.options.steps == 0) {
								$scope.setHandle($scope.track.x);
							}
							else {
								$scope.snapCall();
							}
					}

					$scope.panStart = function(event) {

						$scope.track.startX = event.center.x - $scope.curState.curPos;
						console.log('CURPOS='+ $scope.curState.curPos+' '+$scope.track.startX+' '+event.center.x);
						$scope.curState.touchEvents.panning = true;
						$scope.curState.mouseDown = true;
						$scope.setHandle($scope.track.x);
					}

					$scope.panMove = function(event) {
						$scope.track.x = event.center.x - $scope.track.startX;
						$scope.setHandle($scope.track.x);
					}

					$scope.panEnd = function(event) {
						$scope.curState.touchEvents.panning = false;
						$scope.curState.mouseDown = false;
						$scope.snapToMark();
					}

					$scope.getElementX = function () {
				    return $element.css('left');
				  };

					$scope.$watch($scope.getElementX, function (newValue, oldValue) {
				 });

				 $scope.setHandle = function(x) {
					 var pos = $scope.xLeft(x);
					 $element.css({
						 left:  pos + 'px'
					 });
					$scope.curState.curPos = pos;
					$scope.curState.curPercent = $scope.posPcent(pos);
					var p = $scope.rounder($scope.curState.curPercent,100/$scope.options.steps);
					console.log($scope.curState.curPos+' '+$scope.curState.curPercent+' '+p);
					var nearKey = $scope.getNearKey(p);
					$scope.curState.nearKey = nearKey.idx;
					$scope.curState.nearKeyLabel = nearKey.label;
					return false;
				 }

				 $scope.snapCall = function(k) {
					if(typeof k !== 'undefined') {
						$scope.snapToMark(k);
					}
					else {
						$scope.snapToMark();
					}
					return false;
				}

				$scope.snapToMark = function(k) {
					console.log('SNAP TO MARK '+k);
					 var p = null,nearKey = null;
					 if(typeof k !== 'undefined') {
						 $scope.curState.curPercent = $scope.getKeyPos(k);
					 //	$scope.$apply();
					 }
					 nearKey = $scope.findNearKey($scope.curState.curPercent);
					 $scope.curState.nearKey = nearKey.idx + 1;
					 $scope.curState.curPercent = nearKey.pos;
					 $scope.track.x = $scope.curState.curPos = $scope.pcentPos(nearKey.pos);
					 $scope.curState.nearKeyLabel = nearKey.label;
					 //alert($scope.curState.curPercent+' '+$scope.curState.curPos);
					 $element.css({'left':$scope.curState.curPos + 'px'});
					 $scope.focusKey = ("#sk_" + $scope.options.id) + nearKey.idx;
					 return false;
				 }

					$scope.getKeyLabel = function(p) {
						if($scope.keyMarkers.length > 0) {
							var idx = arraySvce.arrIndexOf($scope.keyMarkers,p,'pos');
							return idx + 1;
						}
						else {
							return 'unknown';
						}
					}

					$scope.findNearKey = function(p) {
						if($scope.keyMarkers.length > 0) {
							var idx = 0;
							var prev = p-5;
							for(var i=0;i<$scope.keyMarkers.length;i++) {
									var diff = Math.abs((p-5)-$scope.keyMarkers[i].pos);
									idx = diff < prev ? i : idx;
									prev = diff;
							}
							var keyData = {
								idx: idx,
								pos: $scope.keyMarkers[idx].pos,
								label: $scope.keyMarkers[idx].label
							}
							return keyData;
						}
						else {
							return 'unknown';
						}
					}

					$scope.getNearKey = function(p) {
						if($scope.keyMarkers.length > 0) {
							var idx = arraySvce.arrIndexOf($scope.keyMarkers,p,'pos');
							var keyData = {
								idx: idx + 1,
								pos: $scope.keyMarkers[idx].pos,
								label: $scope.keyMarkers[idx].label
							}
							return keyData;
						}
						else {
							return 'unknown';
						}
					}

					$scope.getKeyPos = function(k) {
						if($scope.keyMarkers.length > 0) {
						//	alert(k);
							var pos = $scope.keyMarkers[k-1].pos;
							return pos;
						}
						return false;
					}

					$scope.rounder = function (number,to) {
					  	return Math.round(Math.round(number/to)*to);
					}

					$scope.xLeft = function(x) {
						 return Math.round(Math.max( Math.min( $scope.box.w  - ($scope.box.w * 0.06 + $scope.options.maxOffset), x) , $scope.options.minOffset));
					}

					$scope.initSetHandle =function() {
						$scope.track.startX = $scope.xOffset();
						$scope.snapCall($scope.curState.nearKey);
					}

					angular.element($window).bind('resize', function () {
						 $scope.winSize.w = $window.innerWidth;
						 $scope.track.startX = $scope.xOffset();
						 $scope.dimSetup($scope.getElementDimensions());
						 $scope.snapCall($scope.curState.nearKey);
					});

					$scope.$watch('updates', function (newValue, oldValue) {
						if(!angular.equals(newValue,oldValue)) {
							$scope.initSetHandle();
						}
					});

					$scope.$on("$destroy", function() {
						angular.element($window).unbind('resize');
					});

				}]
			};
		}])


.directive("bnFadeHelper",[function() {
                // I alter the DOM to add the fader image.
        function compile( element, attributes, transclude ) {
          	element.prepend( "<img class='fading'/>" );
                return( link );
            }
            // I bind the UI events to the $scope.
            function link( scope, element, attributes ) {

								scope.fader = {};
								scope.primary = {};

								element.ready(function() {
									scope.fader = element[0].querySelector("img.fading");
									scope.primary = element[0].querySelector("img.image");

								scope.$watch(
                      function(){return scope.primary.src;},
                      function( newValue, oldValue ) {
                          if ( newValue === oldValue ) {
                              return;
                          }
                          // If the fader is still fading out, don't
                          // bother changing the source of the fader;
                          // just let the previous image continue to
                          // fade out.
                          if ( isFading() ) {
                              return;
                          }
                          initFade( oldValue );
                      }
                  );

							});

              // I prepare the fader to show the previous image
              // while fading out of view.
              function initFade( fadeSource ) {

									scope.fader.src = fadeSource;
									scope.fader.classList.add("show");
                  // Don't actually start the fade until the
                  // primary image has loaded the new source.
                  //scope.primary.on( "load", startFade );
									scope.primary.addEventListener("load", startFade);
              }
              // I determine if the fader is currently fading
              // out of view (that is currently animated).
							function isFading() {
                  return(
                    scope.fader.classList.contains( "show" ) ||
                    scope.fader.classList.contains( "fadeOut" )
                  );
              }
              // I start the fade-out process.
              function startFade() {
									forceFade()
                  setTimeout( teardownFade, 1000 );
              }
							function forceFade() {
							    setTimeout(function() {
										scope.fader.classList.add("fadeOut");
										return false;
									}, 1);
							}

              function teardownFade() {
									scope.fader.classList.remove("show");
									scope.fader.classList.remove("fadeOut");
              }
          }
          // Return the directive configuration.
          return({
              compile: compile,
              restrict: "A"
          });
      }
]);



// WEBPACK FOOTER //
// ./src/app/js/qms.directives.js